import { useQuery } from "@tanstack/react-query"
import { getSakhas } from "../services/sakhaService"

export const useFetchSakhas = () => {
    return useQuery({
        queryKey: ['sakhas'],
        queryFn: getSakhas
    })
}
